import Hero from "@/components/home/Hero";
import SocialStripe from "@/components/home/SocialStripe";
import SEO from "@/components/layout/SEO";
import PathwaySelector from "@/components/home/PathwaySelector";
import TrustPillars from "@/components/home/TrustPillars";
import ServicesLadder from "@/components/home/ServicesLadder";
import PainPoints from "@/components/home/PainPoints";
import PremiumRouter from "@/components/home/PremiumRouter";
import Proof from "@/components/home/Proof";
import AboutExpert from "@/components/home/AboutExpert";
import LeadMagnet from "@/components/home/LeadMagnet";
import FAQSection from "@/components/home/FAQSection";
import FinalCTA from "@/components/home/FinalCTA";
import EligibilitySection from "@/components/home/EligibilitySection";

export default function Home() {
  return (
    <div data-testid="page-home">
      <SEO
        title="Study in Poland with expert guidance"
        description="Helping international students choose the right university in Poland and move through admissions, visa, and relocation. 15+ years of expert support across 100+ Polish universities."
        path="/"
      />
      <Hero />
      <SocialStripe />
      <PathwaySelector />
      <TrustPillars />
      <ServicesLadder />
      <PainPoints />
      <PremiumRouter />
      <Proof />
      <AboutExpert />
      <LeadMagnet />
      <EligibilitySection />
      <FAQSection />
      <FinalCTA />
    </div>
  );
}
